import { useEffect, useState } from "react";
import axios from "axios";
import { Images } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const GallerySection = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const loadGallery = async () => {
      try {
        const response = await axios.get(`${API}/gallery`);
        setItems(response.data || []);
      } catch (error) {
        setItems([]);
      }
    };
    loadGallery();
  }, []);

  return (
    <section id="gallery" className="px-6 py-16 lg:px-8 lg:py-20" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl" data-testid="gallery-container">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-testid="gallery-heading-row">
          <div data-testid="gallery-heading-block">
            <p className="font-display text-xs uppercase tracking-[0.24em] text-blue-300" data-testid="gallery-eyebrow">Before & after</p>
            <h2 className="mt-4 font-display text-4xl font-light tracking-[-0.04em] text-white sm:text-5xl" data-testid="gallery-title">See real work as it gets added.</h2>
          </div>
          <p className="max-w-md leading-7 text-zinc-400" data-testid="gallery-description">Owners can add actual job photos from the dashboard, so this stays real instead of filled with stock results.</p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-testid="gallery-list">
          {items.map((item) => (
            <article key={item.id} className="overflow-hidden rounded-[2rem] border border-white/10 bg-white/[0.04]" data-testid={`gallery-item-${item.id}`}>
              <div className="grid gap-px bg-white/10 sm:grid-cols-2" data-testid={`gallery-images-${item.id}`}>
                <div className="bg-black" data-testid={`gallery-before-wrapper-${item.id}`}>
                  {item.before_photo_data_url ? <img src={item.before_photo_data_url} alt={`Before ${item.title}`} className="aspect-[4/3] w-full object-cover" data-testid={`gallery-before-image-${item.id}`} /> : <div className="grid aspect-[4/3] place-items-center text-sm text-zinc-500" data-testid={`gallery-before-empty-${item.id}`}>Before photo pending</div>}
                </div>
                <div className="bg-black" data-testid={`gallery-after-wrapper-${item.id}`}>
                  {item.after_photo_data_url ? <img src={item.after_photo_data_url} alt={`After ${item.title}`} className="aspect-[4/3] w-full object-cover" data-testid={`gallery-after-image-${item.id}`} /> : <div className="grid aspect-[4/3] place-items-center text-sm text-zinc-500" data-testid={`gallery-after-empty-${item.id}`}>After photo pending</div>}
                </div>
              </div>
              <div className="p-5" data-testid={`gallery-copy-${item.id}`}>
                <h3 className="font-display text-xl text-white" data-testid={`gallery-item-title-${item.id}`}>{item.title}</h3>
                {item.notes && <p className="mt-2 text-sm leading-6 text-zinc-400" data-testid={`gallery-item-notes-${item.id}`}>{item.notes}</p>}
              </div>
            </article>
          ))}
          {items.length === 0 && (
            <div className="rounded-[2rem] border border-dashed border-white/15 bg-white/[0.03] p-8 text-zinc-400 md:col-span-2" data-testid="gallery-empty-state">
              <Images className="mb-4 h-8 w-8 text-blue-300" />
              Before/after photos will appear here once owners add real job photos.
            </div>
          )}
        </div>
      </div>
    </section>
  );
};